export enum Role {
  SuperAdmin = 'superAdmin',
  Admin = 'admin',
  Teacher = 'teacher',
  Parent = 'parent',
  Support = 'support',
}

export type UserDTO = {
  id: string
  full_name: string
  phone: string | null
  email: string
  email_verified_at: string | null
  profile: Role
  receive_promotional_notifications: boolean
  receive_system_notifications: boolean
  created_at: string
}
